var cov_2o76ntx02e = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Select/index.tsx",
      hash = "0f8babff0143144857372f55c5b928286512d452",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Select/index.tsx",
    statementMap: {
      "0": {
        start: {
          line: 14,
          column: 19
        },
        end: {
          line: 20,
          column: 1
        }
      },
      "1": {
        start: {
          line: 14,
          column: 100
        },
        end: {
          line: 20,
          column: 1
        }
      },
      "2": {
        start: {
          line: 18,
          column: 16
        },
        end: {
          line: 18,
          column: 38
        }
      },
      "3": {
        start: {
          line: 19,
          column: 2
        },
        end: {
          line: 19,
          column: 44
        }
      },
      "4": {
        start: {
          line: 22,
          column: 21
        },
        end: {
          line: 32,
          column: 9
        }
      },
      "5": {
        start: {
          line: 34,
          column: 0
        },
        end: {
          line: 34,
          column: 43
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 14,
            column: 19
          },
          end: {
            line: 14,
            column: 20
          }
        },
        loc: {
          start: {
            line: 14,
            column: 100
          },
          end: {
            line: 20,
            column: 1
          }
        },
        line: 14
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 14,
            column: 100
          },
          end: {
            line: 14,
            column: 101
          }
        },
        loc: {
          start: {
            line: 16,
            column: 5
          },
          end: {
            line: 20,
            column: 1
          }
        },
        line: 16
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 18,
            column: 16
          },
          end: {
            line: 18,
            column: 38
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 18,
            column: 33
          },
          end: {
            line: 18,
            column: 34
          }
        }, {
          start: {
            line: 18,
            column: 37
          },
          end: {
            line: 18,
            column: 38
          }
        }],
        line: 18
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0
    },
    f: {
      "0": 0,
      "1": 0
    },
    b: {
      "0": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

var _this = this,
    _jsxFileName = "/Users/spana/SHEIN/shineout/src/Select/index.tsx";

import React from 'react';
import inputable from '../Form/inputable';
import { compose } from '../utils/func';
import Datum from '../Datum';
import inputBorder from '../hoc/inputBorder';
import { selectClass } from './styles';
import tiled, { advancedFilterHOC } from '../TreeSelect/tiled';
import Select from './Select';
import filter from './filter';
import group from './group';
import absolute from '../Table/context';
cov_2o76ntx02e.s[0]++;

var limitWrap = function limitWrap(Origin) {
  cov_2o76ntx02e.f[0]++;
  cov_2o76ntx02e.s[1]++;
  return function (props) {
    cov_2o76ntx02e.f[1]++;
    // eslint-disable-next-line
    var limit = (cov_2o76ntx02e.s[2]++, props.multiple ? (cov_2o76ntx02e.b[0][0]++, 0) : (cov_2o76ntx02e.b[0][1]++, 1));
    cov_2o76ntx02e.s[3]++;
    return (
      /*#__PURE__*/
      React.createElement(Origin, Object.assign({}, props, {
        limit: limit,
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 19,
          columnNumber: 10
        }
      }))
    );
  };
};

var exportSelect = (cov_2o76ntx02e.s[4]++, compose(inputable, inputBorder({
  className: selectClass('_'),
  tag: 'div'
}), limitWrap, Datum.hoc({
  bindProps: ['disabled', 'limit', 'format', 'prediction', 'separator'],
  pure: false
}), advancedFilterHOC, filter, tiled({
  dataKey: 'treeData'
}), group, absolute)(Select));
cov_2o76ntx02e.s[5]++;
exportSelect.displayName = 'ShineoutSelect';
export default exportSelect;